import { NotificationHost } from "./components/Toast.jsx";
// Reconstructed from the supplied production build; original component names were unavailable.
import { AuthProvider } from "./context/AuthContext.jsx";
import { BrowserRouter, Navigate, Route, Routes } from "./vendor/runtime.js";
import { HomePage } from "./pages/HomePage.jsx";
import { LoginPage } from "./pages/LoginPage.jsx";
import { RegisterPage } from "./pages/RegisterPage.jsx";
import { VerifyEmailPage } from "./pages/VerifyEmailPage.jsx";
import { ProfilePage } from "./pages/ProfilePage.jsx";
import { TermsPage } from "./pages/TermsPage.jsx";
import { MissionPage } from "./pages/MissionPage.jsx";
import { BlogPage } from "./pages/BlogPage.jsx";
import { CopyrightPage } from "./pages/CopyrightPage.jsx";
import { CustomProjectPage } from "./pages/CustomProjectPage.jsx";
import { RequestsPage } from "./pages/RequestsPage.jsx";
import { ProductsPage } from "./pages/ProductsPage.jsx";
import { ProductDetailsPage } from "./pages/ProductDetailsPage.jsx";
import { PurchasesPage } from "./pages/PurchasesPage.jsx";
import { PurchaseDetailsPage } from "./pages/PurchaseDetailsPage.jsx";
import { PrivacyPage } from "./pages/PrivacyPage.jsx";
import { ContactPage } from "./pages/ContactPage.jsx";
import { SupportWidget } from "./components/SupportWidget.jsx";
const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path={"/"} element={<HomePage />} />
        <Route path={"/login"} element={<LoginPage />} />
        <Route path={"/register"} element={<RegisterPage />} />
        <Route path={"/verify"} element={<VerifyEmailPage />} />
        <Route path={"/profile"} element={<ProfilePage />} />
        <Route path={"/terms"} element={<TermsPage />} />
        <Route path={"/mission"} element={<MissionPage />} />
        <Route path={"/blog"} element={<BlogPage />} />
        <Route path={"/copyright"} element={<CopyrightPage />} />
        <Route path={"/custom-project"} element={<CustomProjectPage />} />
        <Route path={"/requests"} element={<RequestsPage />} />
        <Route path={"/products"} element={<ProductsPage />} />
        <Route path={"/products/:id"} element={<ProductDetailsPage />} />
        <Route path={"/projects"} element={<ProductsPage />} />
        <Route path={"/my"} element={<PurchasesPage />} />
        <Route path={"/purchases/:purchaseId"} element={<PurchaseDetailsPage />} />
        <Route path={"/policy"} element={<PrivacyPage />} />
        <Route path={"/contact"} element={<ContactPage />} />
        <Route path={"*"} element={<Navigate to={"/"} replace={true} />} />
      </Routes>
      <SupportWidget />
    </BrowserRouter>
    <NotificationHost />
  </AuthProvider>
);
export { App };
